"use client";
import Link from "next/link";
import { PERKS_AND_BENEFITS, SpecialTeam } from "../../data/careersData";
import ButtonTextIcon from "../_ui/ButtonTextIcon";
import { ListingItemsCareer } from "../common/CommonComponents";
import { AnimatedSection } from "../../utils/helpers";
import CreatableSelect from "react-select/creatable";
import Image from "next/image";
import { FaSearch } from "react-icons/fa";
import { useSearchParams, useRouter } from "next/navigation";
import React, { useMemo, useEffect, useState } from "react";
import { JOBS } from "../../data/jobs";
import { FILTER_OPTIONS } from "../../utils/constants";
import { FaLightbulb } from "react-icons/fa";

export const PerksAndBenefits = () => {
  return (
    <section id="careers-page">
      <div className="perks-benefits">
        <div className="container">
          <div className="row ">
            <div className="top t-a-c l-h-1-2">
              <AnimatedSection animation="slideInUp" speed="800ms">
                <p className="color-white p-25 font-nunito-sans">Thriving Through Benefits</p>
                <h1 className="t-t-u color-white">Perks and Benefits</h1>
              </AnimatedSection>
              <div className="btn">
                <Link href="/current-job-openings" passHref>
                  <ButtonTextIcon
                    style={{
                      minHeight: "60px",
                      zIndex: "11",
                    }}
                    icon={
                      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.8869 9.54111L10.1397 13.0356C9.92875 13.461 9.31703 13.447 9.12367 13.0146L7.12328 8.57432L6.06859 11.095H2.76039L9.1764 17.6517C9.42601 17.9083 9.83031 17.9083 10.0799 17.6517L16.4994 11.095H12.6639L11.8869 9.54111ZM17.2834 3.56807L17.1991 3.48018C15.3885 1.63096 12.4248 1.63096 10.6108 3.48018L9.62992 4.48564L8.64906 3.48369C6.83851 1.63096 3.87132 1.63096 2.06078 3.48369L1.9764 3.56807C0.264292 5.31885 0.190464 8.10674 1.71976 9.97002H5.31976L6.58187 6.93955C6.77171 6.48604 7.41156 6.47549 7.61546 6.92549L9.66156 11.4712L11.3842 8.02939C11.5916 7.61455 12.1823 7.61455 12.3897 8.02939L13.36 9.97002H17.5401C19.0694 8.10674 18.9955 5.31885 17.2834 3.56807Z"
                          fill="black"
                        />
                      </svg>
                    }
                    iconPosition="start"
                    title="CURRENT JOB OPENINGS"
                  />
                </Link>
              </div>
            </div>
            <div className="bottom ">
              <div className="outer-box flex ">
                {PERKS_AND_BENEFITS.length > 0 ? (
                  PERKS_AND_BENEFITS?.map((l, i) => (
                    <div className="inner-box  l-h-2 t-a-c " key={i}>
                      <AnimatedSection animation="fadeIn" delay="0s" speed="slow ">
                        <div className="icon-box flex center-center">
                          <div className="icon flex center-center ">{l.icon}</div>
                        </div>
                        <h6 className="color-white t-t-u font-nunito-sans f-w-800 l-h-1 p-18">{l.title}</h6>
                        <p className="t-a-c color-light-grey p-16 l-h-1 font-nunito-sans">{l.content}</p>
                      </AnimatedSection>
                    </div>
                  ))
                ) : (
                  <div>Noting to show at the moment!</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const Surgical_Assitant = ({ title, content, subHeading, data, image }) => {
  return (
    <section
      id="careers-page"
      style={{
        backgroundColor: "#fff",
      }}
    >
      <div className="surgical-assistant  ">
        <div className="container">
          <div className="flex row ">
            <div className="image-box  ">
              <AnimatedSection animation="slideInLeft" speed="700ms">
                <div className="img">
                  {/* <img className="b-r-10" src={image} alt={title} /> */}
                  <img
                    className="b-r-10"
                    src={image}
                    alt={title}
                  />
                </div>
              </AnimatedSection>
            </div>

            <div className="flex center-left flex-1 ">
              <div className=" sup-content ">
                {/* <h6 className="f-w-400 ">{}</h6>
                <br /> */}
                <h1 className="l-h-1 color-blue f-w-300 font-barlow t-t-u col-4-5 ">{title}</h1>
                <br />
                <p className="font-nunito-sans f-w-300 p-16 l-h-1-2">{content}</p>
                <br />
                <h6 className="font-mont p-18 f-w-600">{subHeading}</h6>

                <div className="content flex ">
                  {/* left */}
                  <ListingItemsCareer data={data} />

                  {/* right
                  <ListingItems data={data} sliceStart={5} /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const CurrentJobOpenings = ({ image }) => {
  const colourOptions = [
    { value: "option 1", label: "Option 1" },
    { value: "option 2", label: "Option 2" },
    { value: "option 3", label: "Option 3" },
  ];

  const searchParams = useSearchParams();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const searchTerm = searchParams.get("search") || "";
  const category = searchParams.get("job__category_spec") || "";
  const [search, setSearch] = useState(searchTerm);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isSearchEdited, setIsSearchEdited] = useState(false);
  const type = searchParams.get("job__type_spec") || "";
  const location = searchParams.get("job__location_spec") || "";
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const normalizeString = (str) => {
    return str
      .trim()
      .replace(/[^a-zA-Z0-9\s]/g, " ")
      .toLowerCase();
  };

  //function to update URL
  const updateURL = (key, value) => {
    const params = new URLSearchParams(searchParams.toString());
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    router.push(`?${params.toString()}`, { scroll: false });
  };

  //===={filter jobs}====
  const filterJobs = JOBS.filter((job) => {
    const isSearchProvided = searchTerm.trim() !== "";
    const isCategoryProvided = category !== "";
    const isTypeProvided = type !== "";
    const isLocationProvided = location !== "";

    if (!isSearchProvided && !isCategoryProvided && !isTypeProvided && !isLocationProvided) {
      return true;
    }

    const matchSearchTerm = !isSearchProvided || job.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategory = !isCategoryProvided || normalizeString(job.category) === normalizeString(category);

    const matchType = !isTypeProvided || normalizeString(job.type) === normalizeString(type);
    const matchLocation = !isLocationProvided || normalizeString(job.location) === normalizeString(location);

    return matchSearchTerm && matchCategory && matchType && matchLocation;
  });

  const handleSearch = () => {
    if (isSearchActive && !isSearchEdited) {
      setIsSearchActive(false);
      setSearch("");
      updateURL("search", "");
      setIsSearchEdited(false);
    } else {
      updateURL("search", search.trim());
      setIsSearchActive(true);
      setIsSearchEdited(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setIsSearchEdited(true);
  };

  const handleFilterClick = () => {
    console.log("on filter clickk");
    setIsFilterVisible(!isFilterVisible);
  };

  //

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();

      if (searchTerm) params.append("q", searchTerm);
      if (category) params.append("category", category);
      if (type) params.append("type", type);
      if (location) params.append("location", location);

      const response = await fetch(`/api/job?${params.toString()}`);
      if (response.ok) {
        const data = await response.json();
        setJobs(data?.result || []);
      } else {
        throw new Error("Failed to fetch jobs");
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [searchTerm, category, type, location]);

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  // Build a map of current values read from URL search params
  const currentValues = useMemo(() => {
    const map = {};
    for (const opt of FILTER_OPTIONS) {
      const val = searchParams.get(opt.key) ?? "";
      map[opt.key] = val;
    }
    return map;
  }, [FILTER_OPTIONS, searchParams]);

  const [dynamicOptions, setDynamicOptions] = useState(() => {
    const init = {};
    for (const opt of FILTER_OPTIONS) {
      init[opt.key] = (opt.options || []).map((o) => ({
        value: o,
        label: humaniseOption(o),
      }));
    }
    return init;
  });
  function humaniseOption(opt) {
    if (!opt) return "";
    const s = String(opt);
    return s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, " ");
  }

  // Handler when user selects or creates an option
  function handleChange(key) {
    return (selected) => {
      if (!selected) {
        updateURL(key, "");
        return;
      }

      // react-select passes either single option object or array (we use single)
      const value = selected.value ?? selected;
      updateURL(key, value);
    };
  }
  // Handler for when user creates new option via CreatableSelect
  function handleCreate(key) {
    return (inputValue) => {
      if (!inputValue) return;
      const newOpt = { value: inputValue, label: humaniseOption(inputValue) };
      setDynamicOptions((prev) => {
        const next = { ...prev };
        next[key] = [newOpt, ...(next[key] || [])];
        return next;
      });
      // set URL to new value immediately
      updateURL(key, inputValue);
    };
  }

  return (
    <section id="service-page" className="team-section" style={{ position: 'relative' }}>
      <div className="overlay" style={{ backgroundColor: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(16px)', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="team-heading">
          <AnimatedSection animation="slideInUp" delay="0s" speed="900ms">
            <div style={{
              background: 'linear-gradient(135deg, rgba(82, 113, 163, 0.95), rgba(51, 80, 127, 0.95))',
              borderRadius: '8px',
              minHeight: '60px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px 32px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
              marginBottom: '32px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                color: '#ffffff',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                fontSize: '17px',
                lineHeight: '1.5',
                fontWeight: '400',
                textAlign: 'center'
              }}>
                <span style={{ fontSize: '20px', flexShrink: 0 }}>💡</span>
                <span>
                  We offer flexible work options — apply as a <strong>Full-Time employee</strong> or an <strong>Independent Contractor</strong>.
                </span>
              </div>
            </div>

            <h1 className="l-h-1 font-barlow f-w-300" style={{ fontSize: "56px", color: "#45AFF1" }}>
              Current Job Openings
            </h1>
          </AnimatedSection>
        </div>
        <div className="filters">
          <div className="search">
            {/* <input type="text" placeholder="Search" /> */}
            <input type="text" placeholder="Search Jobs..." value={search} onChange={handleSearchChange} onKeyDown={handleSearchKeyDown}></input>
            <div className="icon-filter center-center  b-r-5" onClick={handleFilterClick}>
              <FaSearch className="color-black" />
            </div>
          </div>
          {/* <div>
            <CreatableSelect isClearable options={colourOptions} placeholder="Job Categories" />
          </div> */}
          {FILTER_OPTIONS.map(({ key, label }) => {
            const options = dynamicOptions[key] || [];
            const valueFromUrl = currentValues[key] || "";

            // find selected option object if present in options, else create temporary object
            const selectedOption =
              options.find((o) => o.value === valueFromUrl) || (valueFromUrl ? { value: valueFromUrl, label: humaniseOption(valueFromUrl) } : null);

            return (
              <div key={key} className={key.split("__")[1]?.replace("_spec", "") ?? key}>
                <CreatableSelect
                  isClearable
                  options={options}
                  placeholder={label}
                  onChange={handleChange(key)}
                  onCreateOption={handleCreate(key)}
                  value={selectedOption}
                />
              </div>
            );
          })}
          {/* <div>
            <CreatableSelect isClearable options={colourOptions} placeholder="Job Types" />
          </div>
          <div>
            <CreatableSelect isClearable options={colourOptions} placeholder="Job Locations" />
          </div> */}
        </div>
        {/* <div className="team-grid">
          {SpecialTeam.map((item, idx) => (
            <AnimatedSection key={idx} animation="fadeIn" delay={`${0.05 * idx}s`}>
              <article className="team-card">
                <div className="card-head">
              
                  <Image
                    className="b-r-5"
                    src={item.icon}
                    alt={item.icon}
                    width={80} // set your preferred width
                    height={80} // set your preferred height
                  />
           
                  <div>
                    <div className="card-title">{item.title}</div>
                  </div>
                </div>

                <div className="apply-btn">
                  <button className="p-14 f-w-700 font-nunito-sans">Apply Now</button>
                  <div className="card-title">{item.title1}</div>
                  <div className="card-title">{item.title2}</div>
                </div>

                <div className="p-14 f-w-400 font-nunito-sans card-desc">{item.content}</div>
              </article>
            </AnimatedSection>
          ))}
        </div> */}

        <div className="team-grid">
          {loading ? (
            <div style={{ width: "100%" }} className="flex center-center">
              <p className="t-a-c">Loading jobs...</p>
            </div>
          ) : jobs?.length > 0 ? (
            jobs.map((job, idx) => {
              // map job fields to the team-card structure
              const title = job.Name ?? "Untitled";
              const title1 = job.Category ?? "";
              const title2 = job.Category ? `${job.Category} • ${job.JobType ?? ""}` : job.JobType ?? "";
              const content = job.Description ?? "";
              const iconSrc = SpecialTeam[idx % SpecialTeam.length]?.icon || "/images/special-team/1.png";
              console.log("icon src ---", iconSrc);
              return (
                <AnimatedSection key={job.Id || title} animation="fadeIn" delay={`${0.05 * idx}s`} className="blur">
                  <article className="team-card">
                    <div className="card-head">
                      <img
                        className="b-r-5"
                        src={iconSrc}
                        alt={iconSrc}
                        width="80"
                        height="80"
                      />
                      <div>
                        <div className="card-title">{title}</div>
                      </div>
                    </div>

                    <div className="apply-btn">
                      <div className="card-title">POSITION</div>
                      <div className="card-title">{title1}</div>

                      {/* Apply button navigates to job page or apply route */}
                      <Link href={`/jobs/${job.Id ?? ""}`}>
                        <button className="p-14 f-w-700 font-nunito-sans">Apply Now</button>
                      </Link>
                    </div>

                    <div className="p-14 f-w-400 font-nunito-sans card-desc">{content}</div>
                  </article>
                </AnimatedSection>
              );
            })
          ) : (
            <div style={{ width: "100%" }} className="flex center-center">
              <p className="t-a-c" style={{ color: "#fff", fontSize: 26 }}>
                Sorry! No jobs to show.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
